import { createStore, createEvent } from "effector";
import { PAGES, TotemLaundryStoreState } from "./LaundryStore.types";
import { laundryStoreInteraction, laundryStoreState } from "./LaundryStore.consts";
import { LaundryMachineOption, LaundryTypeOption, PaymentOption } from "../../types/laundry.types";
import { fetchLaundryMachinesEffect, fetchLaundryTypesEffect } from "./LaundryStore.effects";

// Eventos (ações)
export const setPage = createEvent<PAGES>('setPage');
export const setSelectedLaundryMachine = createEvent<LaundryMachineOption>('setSelectedLaundryMachine');
export const setTaxId = createEvent<string>('setTaxId');
export const setSelectedLaundryType = createEvent<LaundryTypeOption>('setSelectedLaundryType');
export const setSelectedPayment = createEvent<PaymentOption>('setSelectedPayment');
export const setFinalPrice = createEvent<number>('setFinalPrice');
export const setTotemId = createEvent<string>('setTotemId');
export const setTerminalId = createEvent<string>('setTerminalId');
export const setPaymentId = createEvent<string>('setPaymentId');
export const setCieloTransactionId = createEvent<string>('setCieloTransactionId');
export const setErrorMsg = createEvent<string>('setErrorMsg');
export const restartInteraction = createEvent('restartInteraction');
export const resetLaundryStore = createEvent();

// Store inicial
export const LaundryStore = createStore<TotemLaundryStoreState>(laundryStoreState)
  .on(setPage, (store, page) => ({
    ...store,
    currPage: page
  }))
  .on(setSelectedLaundryType, (store, selectedLaundryType) => ({
    ...store,
    selectedLaundryType
  }))
  .on(setSelectedPayment, (store, selectedPayment) => ({
    ...store,
    selectedPayment
  }))
  .on(setFinalPrice, (store, finalPrice) => ({
    ...store,
    finalPrice
  }))
  .on(setTotemId, (store, totemId) => ({
    ...store,
    totemId
  }))
  .on(setTerminalId, (store, terminalId) => ({
    ...store,
    terminalId
  }))
  .on(setPaymentId, (store, paymentId) => ({
    ...store,
    paymentId
  }))
  .on(setCieloTransactionId, (store, cieloTransactionId) => ({
    ...store,
    cieloTransactionId
  }))
  .on(setErrorMsg, (store, errorMsg) => ({
    ...store,
    errorMsg
  }))
  .on(setSelectedLaundryMachine, (store, selectedLaundryMachine) => ({
    ...store,
    selectedLaundryMachine
  }))
  .on(setTaxId, (store, taxId) => ({
    ...store,
    taxId
  }))
  .on(fetchLaundryTypesEffect.doneData, (store, laundryTypeOptions) => {
    const availableLaundryTypes = laundryTypeOptions;
    if(!availableLaundryTypes.length) {
      availableLaundryTypes.push({} as LaundryTypeOption);
    }
    return ({
      ...store,
      laundryTypeOptions,
      selectedLaundryType: availableLaundryTypes[0]
    })
  })
  .on(fetchLaundryMachinesEffect.doneData, (store, laundryMachineOptions) => {
    const availableLaundryMachines = laundryMachineOptions;
    if(!availableLaundryMachines.length) {
      availableLaundryMachines.push({} as LaundryMachineOption);
    }
    return ({
      ...store,
      laundryMachineOptions,
      selectedLaundryMachine: availableLaundryMachines[0]
    })
  })
  .on(restartInteraction, (store) => ({
    ...store,
    ...laundryStoreInteraction
  }))
  .reset(resetLaundryStore);
